import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, fmtDate, fmtTime, payLabel } from "@/lib/api";
import { StatusPill } from "@/components/StatusPill";

export default function WorkerCalendar() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    (async () => {
      const { data } = await api.get("/worker/shifts");
      setItems(data);
    })();
  }, []);

  return (
    <div data-testid="worker-calendar">
      <p className="overline">Calendar</p>
      <h1 className="mt-3 font-display text-3xl font-semibold tracking-tight sm:text-4xl">My upcoming shifts</h1>

      {items.length === 0 ? (
        <p className="card-surface mt-8 p-8 text-sm text-slate-600" data-testid="calendar-empty">
          Nothing on your calendar yet. Express interest in a shift to get started.
        </p>
      ) : (
        <div className="card-surface mt-8 overflow-x-auto">
          <table className="w-full min-w-[720px] text-sm">
            <thead className="border-b border-slate-200 bg-slate-50/60 text-left">
              <tr className="[&>th]:px-5 [&>th]:py-3">
                <th className="overline">Date</th>
                <th className="overline">Role</th>
                <th className="overline">Pharmacy</th>
                <th className="overline">Time</th>
                <th className="overline">Pay</th>
                <th className="overline">Status</th>
                <th />
              </tr>
            </thead>
            <tbody>
              {items.map((s) => (
                <tr key={s.shift_id} className="border-b border-slate-100 last:border-0" data-testid={`calendar-row-${s.shift_id}`}>
                  <td className="px-5 py-4 font-medium">{fmtDate(s.date, { weekday: "short", month: "short", day: "numeric" })}</td>
                  <td className="px-5 py-4">{s.worker_role}</td>
                  <td className="px-5 py-4">{s.pharmacy?.name}</td>
                  <td className="px-5 py-4">{fmtTime(s.start_time)} – {fmtTime(s.end_time)}</td>
                  <td className="px-5 py-4 font-display font-semibold">{payLabel(s)}</td>
                  <td className="px-5 py-4"><StatusPill status={s.my_status || s.status} /></td>
                  <td className="px-5 py-4">
                    <Link to={`/worker/shifts/${s.shift_id}`} className="text-sm font-medium text-brand" data-testid={`calendar-view-${s.shift_id}`}>
                      View
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
